/**
 * Country -> IANA timezone table, generated from the tzdata `zone.tab` and
 * `iso3166.tab` shipped with the OS. Regenerate with
 * `scripts/gen-timezones.mjs` rather than editing by hand.
 *
 * Only canonical zones are listed — tzdata's backward-compatibility links
 * ("US/Eastern", "Asia/Calcutta") still parse fine at runtime, they just are
 * not offered as choices.
 */
export const COUNTRIES = [
    { code: 'AF', name: 'Afghanistan', zones: ['Asia/Kabul'] },
    { code: 'AX', name: 'Åland Islands', zones: ['Europe/Mariehamn'] },
    { code: 'AL', name: 'Albania', zones: ['Europe/Tirane'] },
    { code: 'DZ', name: 'Algeria', zones: ['Africa/Algiers'] },
    { code: 'AD', name: 'Andorra', zones: ['Europe/Andorra'] },
    { code: 'AO', name: 'Angola', zones: ['Africa/Luanda'] },
    { code: 'AI', name: 'Anguilla', zones: ['America/Anguilla'] },
    { code: 'AQ', name: 'Antarctica', zones: ['Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Mawson', 'Antarctica/McMurdo', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Troll', 'Antarctica/Vostok'] },
    { code: 'AG', name: 'Antigua & Barbuda', zones: ['America/Antigua'] },
    { code: 'AR', name: 'Argentina', zones: ['America/Argentina/Buenos_Aires', 'America/Argentina/Catamarca', 'America/Argentina/Cordoba', 'America/Argentina/Jujuy', 'America/Argentina/La_Rioja', 'America/Argentina/Mendoza', 'America/Argentina/Rio_Gallegos', 'America/Argentina/Salta', 'America/Argentina/San_Juan', 'America/Argentina/San_Luis', 'America/Argentina/Tucuman', 'America/Argentina/Ushuaia'] },
    { code: 'AM', name: 'Armenia', zones: ['Asia/Yerevan'] },
    { code: 'AW', name: 'Aruba', zones: ['America/Aruba'] },
    { code: 'AU', name: 'Australia', zones: ['Antarctica/Macquarie', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Broken_Hill', 'Australia/Darwin', 'Australia/Eucla', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Lord_Howe', 'Australia/Melbourne', 'Australia/Perth', 'Australia/Sydney'] },
    { code: 'AT', name: 'Austria', zones: ['Europe/Vienna'] },
    { code: 'AZ', name: 'Azerbaijan', zones: ['Asia/Baku'] },
    { code: 'BS', name: 'Bahamas', zones: ['America/Nassau'] },
    { code: 'BH', name: 'Bahrain', zones: ['Asia/Bahrain'] },
    { code: 'BD', name: 'Bangladesh', zones: ['Asia/Dhaka'] },
    { code: 'BB', name: 'Barbados', zones: ['America/Barbados'] },
    { code: 'BY', name: 'Belarus', zones: ['Europe/Minsk'] },
    { code: 'BE', name: 'Belgium', zones: ['Europe/Brussels'] },
    { code: 'BZ', name: 'Belize', zones: ['America/Belize'] },
    { code: 'BJ', name: 'Benin', zones: ['Africa/Porto-Novo'] },
    { code: 'BM', name: 'Bermuda', zones: ['Atlantic/Bermuda'] },
    { code: 'BT', name: 'Bhutan', zones: ['Asia/Thimphu'] },
    { code: 'BO', name: 'Bolivia', zones: ['America/La_Paz'] },
    { code: 'BA', name: 'Bosnia & Herzegovina', zones: ['Europe/Sarajevo'] },
    { code: 'BW', name: 'Botswana', zones: ['Africa/Gaborone'] },
    { code: 'BR', name: 'Brazil', zones: ['America/Araguaina', 'America/Bahia', 'America/Belem', 'America/Boa_Vista', 'America/Campo_Grande', 'America/Cuiaba', 'America/Eirunepe', 'America/Fortaleza', 'America/Maceio', 'America/Manaus', 'America/Noronha', 'America/Porto_Velho', 'America/Recife', 'America/Rio_Branco', 'America/Santarem', 'America/Sao_Paulo'] },
    { code: 'GB', name: 'Britain (UK)', zones: ['Europe/London'] },
    { code: 'IO', name: 'British Indian Ocean Territory', zones: ['Indian/Chagos'] },
    { code: 'BN', name: 'Brunei', zones: ['Asia/Brunei'] },
    { code: 'BG', name: 'Bulgaria', zones: ['Europe/Sofia'] },
    { code: 'BF', name: 'Burkina Faso', zones: ['Africa/Ouagadougou'] },
    { code: 'BI', name: 'Burundi', zones: ['Africa/Bujumbura'] },
    { code: 'KH', name: 'Cambodia', zones: ['Asia/Phnom_Penh'] },
    { code: 'CM', name: 'Cameroon', zones: ['Africa/Douala'] },
    { code: 'CA', name: 'Canada', zones: ['America/Atikokan', 'America/Blanc-Sablon', 'America/Cambridge_Bay', 'America/Creston', 'America/Dawson', 'America/Dawson_Creek', 'America/Edmonton', 'America/Fort_Nelson', 'America/Glace_Bay', 'America/Goose_Bay', 'America/Halifax', 'America/Inuvik', 'America/Iqaluit', 'America/Moncton', 'America/Rankin_Inlet', 'America/Regina', 'America/Resolute', 'America/St_Johns', 'America/Swift_Current', 'America/Toronto', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg'] },
    { code: 'CV', name: 'Cape Verde', zones: ['Atlantic/Cape_Verde'] },
    { code: 'BQ', name: 'Caribbean NL', zones: ['America/Kralendijk'] },
    { code: 'KY', name: 'Cayman Islands', zones: ['America/Cayman'] },
    { code: 'CF', name: 'Central African Rep.', zones: ['Africa/Bangui'] },
    { code: 'TD', name: 'Chad', zones: ['Africa/Ndjamena'] },
    { code: 'CL', name: 'Chile', zones: ['America/Coyhaique', 'America/Punta_Arenas', 'America/Santiago', 'Pacific/Easter'] },
    { code: 'CN', name: 'China', zones: ['Asia/Shanghai', 'Asia/Urumqi'] },
    { code: 'CX', name: 'Christmas Island', zones: ['Indian/Christmas'] },
    { code: 'CC', name: 'Cocos (Keeling) Islands', zones: ['Indian/Cocos'] },
    { code: 'CO', name: 'Colombia', zones: ['America/Bogota'] },
    { code: 'KM', name: 'Comoros', zones: ['Indian/Comoro'] },
    { code: 'CD', name: 'Congo (Dem. Rep.)', zones: ['Africa/Kinshasa', 'Africa/Lubumbashi'] },
    { code: 'CG', name: 'Congo (Rep.)', zones: ['Africa/Brazzaville'] },
    { code: 'CK', name: 'Cook Islands', zones: ['Pacific/Rarotonga'] },
    { code: 'CR', name: 'Costa Rica', zones: ['America/Costa_Rica'] },
    { code: 'CI', name: 'Côte d’Ivoire', zones: ['Africa/Abidjan'] },
    { code: 'HR', name: 'Croatia', zones: ['Europe/Zagreb'] },
    { code: 'CU', name: 'Cuba', zones: ['America/Havana'] },
    { code: 'CW', name: 'Curaçao', zones: ['America/Curacao'] },
    { code: 'CY', name: 'Cyprus', zones: ['Asia/Famagusta', 'Asia/Nicosia'] },
    { code: 'CZ', name: 'Czech Republic', zones: ['Europe/Prague'] },
    { code: 'DK', name: 'Denmark', zones: ['Europe/Copenhagen'] },
    { code: 'DJ', name: 'Djibouti', zones: ['Africa/Djibouti'] },
    { code: 'DM', name: 'Dominica', zones: ['America/Dominica'] },
    { code: 'DO', name: 'Dominican Republic', zones: ['America/Santo_Domingo'] },
    { code: 'TL', name: 'East Timor', zones: ['Asia/Dili'] },
    { code: 'EC', name: 'Ecuador', zones: ['America/Guayaquil', 'Pacific/Galapagos'] },
    { code: 'EG', name: 'Egypt', zones: ['Africa/Cairo'] },
    { code: 'SV', name: 'El Salvador', zones: ['America/El_Salvador'] },
    { code: 'GQ', name: 'Equatorial Guinea', zones: ['Africa/Malabo'] },
    { code: 'ER', name: 'Eritrea', zones: ['Africa/Asmara'] },
    { code: 'EE', name: 'Estonia', zones: ['Europe/Tallinn'] },
    { code: 'SZ', name: 'Eswatini (Swaziland)', zones: ['Africa/Mbabane'] },
    { code: 'ET', name: 'Ethiopia', zones: ['Africa/Addis_Ababa'] },
    { code: 'FK', name: 'Falkland Islands', zones: ['Atlantic/Stanley'] },
    { code: 'FO', name: 'Faroe Islands', zones: ['Atlantic/Faroe'] },
    { code: 'FJ', name: 'Fiji', zones: ['Pacific/Fiji'] },
    { code: 'FI', name: 'Finland', zones: ['Europe/Helsinki'] },
    { code: 'FR', name: 'France', zones: ['Europe/Paris'] },
    { code: 'GF', name: 'French Guiana', zones: ['America/Cayenne'] },
    { code: 'PF', name: 'French Polynesia', zones: ['Pacific/Gambier', 'Pacific/Marquesas', 'Pacific/Tahiti'] },
    { code: 'TF', name: 'French S. Terr.', zones: ['Indian/Kerguelen'] },
    { code: 'GA', name: 'Gabon', zones: ['Africa/Libreville'] },
    { code: 'GM', name: 'Gambia', zones: ['Africa/Banjul'] },
    { code: 'GE', name: 'Georgia', zones: ['Asia/Tbilisi'] },
    { code: 'DE', name: 'Germany', zones: ['Europe/Berlin', 'Europe/Busingen'] },
    { code: 'GH', name: 'Ghana', zones: ['Africa/Accra'] },
    { code: 'GI', name: 'Gibraltar', zones: ['Europe/Gibraltar'] },
    { code: 'GR', name: 'Greece', zones: ['Europe/Athens'] },
    { code: 'GL', name: 'Greenland', zones: ['America/Danmarkshavn', 'America/Nuuk', 'America/Scoresbysund', 'America/Thule'] },
    { code: 'GD', name: 'Grenada', zones: ['America/Grenada'] },
    { code: 'GP', name: 'Guadeloupe', zones: ['America/Guadeloupe'] },
    { code: 'GU', name: 'Guam', zones: ['Pacific/Guam'] },
    { code: 'GT', name: 'Guatemala', zones: ['America/Guatemala'] },
    { code: 'GG', name: 'Guernsey', zones: ['Europe/Guernsey'] },
    { code: 'GN', name: 'Guinea', zones: ['Africa/Conakry'] },
    { code: 'GW', name: 'Guinea-Bissau', zones: ['Africa/Bissau'] },
    { code: 'GY', name: 'Guyana', zones: ['America/Guyana'] },
    { code: 'HT', name: 'Haiti', zones: ['America/Port-au-Prince'] },
    { code: 'HN', name: 'Honduras', zones: ['America/Tegucigalpa'] },
    { code: 'HK', name: 'Hong Kong', zones: ['Asia/Hong_Kong'] },
    { code: 'HU', name: 'Hungary', zones: ['Europe/Budapest'] },
    { code: 'IS', name: 'Iceland', zones: ['Atlantic/Reykjavik'] },
    { code: 'IN', name: 'India', zones: ['Asia/Kolkata'] },
    { code: 'ID', name: 'Indonesia', zones: ['Asia/Jakarta', 'Asia/Jayapura', 'Asia/Makassar', 'Asia/Pontianak'] },
    { code: 'IR', name: 'Iran', zones: ['Asia/Tehran'] },
    { code: 'IQ', name: 'Iraq', zones: ['Asia/Baghdad'] },
    { code: 'IE', name: 'Ireland', zones: ['Europe/Dublin'] },
    { code: 'IM', name: 'Isle of Man', zones: ['Europe/Isle_of_Man'] },
    { code: 'IL', name: 'Israel', zones: ['Asia/Jerusalem'] },
    { code: 'IT', name: 'Italy', zones: ['Europe/Rome'] },
    { code: 'JM', name: 'Jamaica', zones: ['America/Jamaica'] },
    { code: 'JP', name: 'Japan', zones: ['Asia/Tokyo'] },
    { code: 'JE', name: 'Jersey', zones: ['Europe/Jersey'] },
    { code: 'JO', name: 'Jordan', zones: ['Asia/Amman'] },
    { code: 'KZ', name: 'Kazakhstan', zones: ['Asia/Almaty', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Atyrau', 'Asia/Oral', 'Asia/Qostanay', 'Asia/Qyzylorda'] },
    { code: 'KE', name: 'Kenya', zones: ['Africa/Nairobi'] },
    { code: 'KI', name: 'Kiribati', zones: ['Pacific/Kanton', 'Pacific/Kiritimati', 'Pacific/Tarawa'] },
    { code: 'KP', name: 'Korea (North)', zones: ['Asia/Pyongyang'] },
    { code: 'KR', name: 'Korea (South)', zones: ['Asia/Seoul'] },
    { code: 'KW', name: 'Kuwait', zones: ['Asia/Kuwait'] },
    { code: 'KG', name: 'Kyrgyzstan', zones: ['Asia/Bishkek'] },
    { code: 'LA', name: 'Laos', zones: ['Asia/Vientiane'] },
    { code: 'LV', name: 'Latvia', zones: ['Europe/Riga'] },
    { code: 'LB', name: 'Lebanon', zones: ['Asia/Beirut'] },
    { code: 'LS', name: 'Lesotho', zones: ['Africa/Maseru'] },
    { code: 'LR', name: 'Liberia', zones: ['Africa/Monrovia'] },
    { code: 'LY', name: 'Libya', zones: ['Africa/Tripoli'] },
    { code: 'LI', name: 'Liechtenstein', zones: ['Europe/Vaduz'] },
    { code: 'LT', name: 'Lithuania', zones: ['Europe/Vilnius'] },
    { code: 'LU', name: 'Luxembourg', zones: ['Europe/Luxembourg'] },
    { code: 'MO', name: 'Macau', zones: ['Asia/Macau'] },
    { code: 'MG', name: 'Madagascar', zones: ['Indian/Antananarivo'] },
    { code: 'MW', name: 'Malawi', zones: ['Africa/Blantyre'] },
    { code: 'MY', name: 'Malaysia', zones: ['Asia/Kuala_Lumpur', 'Asia/Kuching'] },
    { code: 'MV', name: 'Maldives', zones: ['Indian/Maldives'] },
    { code: 'ML', name: 'Mali', zones: ['Africa/Bamako'] },
    { code: 'MT', name: 'Malta', zones: ['Europe/Malta'] },
    { code: 'MH', name: 'Marshall Islands', zones: ['Pacific/Kwajalein', 'Pacific/Majuro'] },
    { code: 'MQ', name: 'Martinique', zones: ['America/Martinique'] },
    { code: 'MR', name: 'Mauritania', zones: ['Africa/Nouakchott'] },
    { code: 'MU', name: 'Mauritius', zones: ['Indian/Mauritius'] },
    { code: 'YT', name: 'Mayotte', zones: ['Indian/Mayotte'] },
    { code: 'MX', name: 'Mexico', zones: ['America/Bahia_Banderas', 'America/Cancun', 'America/Chihuahua', 'America/Ciudad_Juarez', 'America/Hermosillo', 'America/Matamoros', 'America/Mazatlan', 'America/Merida', 'America/Mexico_City', 'America/Monterrey', 'America/Ojinaga', 'America/Tijuana'] },
    { code: 'FM', name: 'Micronesia', zones: ['Pacific/Chuuk', 'Pacific/Kosrae', 'Pacific/Pohnpei'] },
    { code: 'MD', name: 'Moldova', zones: ['Europe/Chisinau'] },
    { code: 'MC', name: 'Monaco', zones: ['Europe/Monaco'] },
    { code: 'MN', name: 'Mongolia', zones: ['Asia/Hovd', 'Asia/Ulaanbaatar'] },
    { code: 'ME', name: 'Montenegro', zones: ['Europe/Podgorica'] },
    { code: 'MS', name: 'Montserrat', zones: ['America/Montserrat'] },
    { code: 'MA', name: 'Morocco', zones: ['Africa/Casablanca'] },
    { code: 'MZ', name: 'Mozambique', zones: ['Africa/Maputo'] },
    { code: 'MM', name: 'Myanmar (Burma)', zones: ['Asia/Yangon'] },
    { code: 'NA', name: 'Namibia', zones: ['Africa/Windhoek'] },
    { code: 'NR', name: 'Nauru', zones: ['Pacific/Nauru'] },
    { code: 'NP', name: 'Nepal', zones: ['Asia/Kathmandu'] },
    { code: 'NL', name: 'Netherlands', zones: ['Europe/Amsterdam'] },
    { code: 'NC', name: 'New Caledonia', zones: ['Pacific/Noumea'] },
    { code: 'NZ', name: 'New Zealand', zones: ['Pacific/Auckland', 'Pacific/Chatham'] },
    { code: 'NI', name: 'Nicaragua', zones: ['America/Managua'] },
    { code: 'NE', name: 'Niger', zones: ['Africa/Niamey'] },
    { code: 'NG', name: 'Nigeria', zones: ['Africa/Lagos'] },
    { code: 'NU', name: 'Niue', zones: ['Pacific/Niue'] },
    { code: 'NF', name: 'Norfolk Island', zones: ['Pacific/Norfolk'] },
    { code: 'MK', name: 'North Macedonia', zones: ['Europe/Skopje'] },
    { code: 'MP', name: 'Northern Mariana Islands', zones: ['Pacific/Saipan'] },
    { code: 'NO', name: 'Norway', zones: ['Europe/Oslo'] },
    { code: 'OM', name: 'Oman', zones: ['Asia/Muscat'] },
    { code: 'PK', name: 'Pakistan', zones: ['Asia/Karachi'] },
    { code: 'PW', name: 'Palau', zones: ['Pacific/Palau'] },
    { code: 'PS', name: 'Palestine', zones: ['Asia/Gaza', 'Asia/Hebron'] },
    { code: 'PA', name: 'Panama', zones: ['America/Panama'] },
    { code: 'PG', name: 'Papua New Guinea', zones: ['Pacific/Bougainville', 'Pacific/Port_Moresby'] },
    { code: 'PY', name: 'Paraguay', zones: ['America/Asuncion'] },
    { code: 'PE', name: 'Peru', zones: ['America/Lima'] },
    { code: 'PH', name: 'Philippines', zones: ['Asia/Manila'] },
    { code: 'PN', name: 'Pitcairn', zones: ['Pacific/Pitcairn'] },
    { code: 'PL', name: 'Poland', zones: ['Europe/Warsaw'] },
    { code: 'PT', name: 'Portugal', zones: ['Atlantic/Azores', 'Atlantic/Madeira', 'Europe/Lisbon'] },
    { code: 'PR', name: 'Puerto Rico', zones: ['America/Puerto_Rico'] },
    { code: 'QA', name: 'Qatar', zones: ['Asia/Qatar'] },
    { code: 'RE', name: 'Réunion', zones: ['Indian/Reunion'] },
    { code: 'RO', name: 'Romania', zones: ['Europe/Bucharest'] },
    { code: 'RU', name: 'Russia', zones: ['Asia/Anadyr', 'Asia/Barnaul', 'Asia/Chita', 'Asia/Irkutsk', 'Asia/Kamchatka', 'Asia/Khandyga', 'Asia/Krasnoyarsk', 'Asia/Magadan', 'Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk', 'Asia/Sakhalin', 'Asia/Srednekolymsk', 'Asia/Tomsk', 'Asia/Ust-Nera', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yekaterinburg', 'Europe/Astrakhan', 'Europe/Kaliningrad', 'Europe/Kirov', 'Europe/Moscow', 'Europe/Samara', 'Europe/Saratov', 'Europe/Ulyanovsk', 'Europe/Volgograd'] },
    { code: 'RW', name: 'Rwanda', zones: ['Africa/Kigali'] },
    { code: 'AS', name: 'Samoa (American)', zones: ['Pacific/Pago_Pago'] },
    { code: 'WS', name: 'Samoa (western)', zones: ['Pacific/Apia'] },
    { code: 'SM', name: 'San Marino', zones: ['Europe/San_Marino'] },
    { code: 'ST', name: 'Sao Tome & Principe', zones: ['Africa/Sao_Tome'] },
    { code: 'SA', name: 'Saudi Arabia', zones: ['Asia/Riyadh'] },
    { code: 'SN', name: 'Senegal', zones: ['Africa/Dakar'] },
    { code: 'RS', name: 'Serbia', zones: ['Europe/Belgrade'] },
    { code: 'SC', name: 'Seychelles', zones: ['Indian/Mahe'] },
    { code: 'SL', name: 'Sierra Leone', zones: ['Africa/Freetown'] },
    { code: 'SG', name: 'Singapore', zones: ['Asia/Singapore'] },
    { code: 'SK', name: 'Slovakia', zones: ['Europe/Bratislava'] },
    { code: 'SI', name: 'Slovenia', zones: ['Europe/Ljubljana'] },
    { code: 'SB', name: 'Solomon Islands', zones: ['Pacific/Guadalcanal'] },
    { code: 'SO', name: 'Somalia', zones: ['Africa/Mogadishu'] },
    { code: 'ZA', name: 'South Africa', zones: ['Africa/Johannesburg'] },
    { code: 'GS', name: 'South Georgia & the South Sandwich Islands', zones: ['Atlantic/South_Georgia'] },
    { code: 'SS', name: 'South Sudan', zones: ['Africa/Juba'] },
    { code: 'ES', name: 'Spain', zones: ['Africa/Ceuta', 'Atlantic/Canary', 'Europe/Madrid'] },
    { code: 'LK', name: 'Sri Lanka', zones: ['Asia/Colombo'] },
    { code: 'BL', name: 'St Barthelemy', zones: ['America/St_Barthelemy'] },
    { code: 'SH', name: 'St Helena', zones: ['Atlantic/St_Helena'] },
    { code: 'KN', name: 'St Kitts & Nevis', zones: ['America/St_Kitts'] },
    { code: 'LC', name: 'St Lucia', zones: ['America/St_Lucia'] },
    { code: 'SX', name: 'St Maarten (Dutch)', zones: ['America/Lower_Princes'] },
    { code: 'MF', name: 'St Martin (French)', zones: ['America/Marigot'] },
    { code: 'PM', name: 'St Pierre & Miquelon', zones: ['America/Miquelon'] },
    { code: 'VC', name: 'St Vincent', zones: ['America/St_Vincent'] },
    { code: 'SD', name: 'Sudan', zones: ['Africa/Khartoum'] },
    { code: 'SR', name: 'Suriname', zones: ['America/Paramaribo'] },
    { code: 'SJ', name: 'Svalbard & Jan Mayen', zones: ['Arctic/Longyearbyen'] },
    { code: 'SE', name: 'Sweden', zones: ['Europe/Stockholm'] },
    { code: 'CH', name: 'Switzerland', zones: ['Europe/Zurich'] },
    { code: 'SY', name: 'Syria', zones: ['Asia/Damascus'] },
    { code: 'TW', name: 'Taiwan', zones: ['Asia/Taipei'] },
    { code: 'TJ', name: 'Tajikistan', zones: ['Asia/Dushanbe'] },
    { code: 'TZ', name: 'Tanzania', zones: ['Africa/Dar_es_Salaam'] },
    { code: 'TH', name: 'Thailand', zones: ['Asia/Bangkok'] },
    { code: 'TG', name: 'Togo', zones: ['Africa/Lome'] },
    { code: 'TK', name: 'Tokelau', zones: ['Pacific/Fakaofo'] },
    { code: 'TO', name: 'Tonga', zones: ['Pacific/Tongatapu'] },
    { code: 'TT', name: 'Trinidad & Tobago', zones: ['America/Port_of_Spain'] },
    { code: 'TN', name: 'Tunisia', zones: ['Africa/Tunis'] },
    { code: 'TR', name: 'Turkey', zones: ['Europe/Istanbul'] },
    { code: 'TM', name: 'Turkmenistan', zones: ['Asia/Ashgabat'] },
    { code: 'TC', name: 'Turks & Caicos Is', zones: ['America/Grand_Turk'] },
    { code: 'TV', name: 'Tuvalu', zones: ['Pacific/Funafuti'] },
    { code: 'UG', name: 'Uganda', zones: ['Africa/Kampala'] },
    { code: 'UA', name: 'Ukraine', zones: ['Europe/Kyiv', 'Europe/Simferopol'] },
    { code: 'AE', name: 'United Arab Emirates', zones: ['Asia/Dubai'] },
    { code: 'US', name: 'United States', zones: ['America/Adak', 'America/Anchorage', 'America/Boise', 'America/Chicago', 'America/Denver', 'America/Detroit', 'America/Indiana/Indianapolis', 'America/Indiana/Knox', 'America/Indiana/Marengo', 'America/Indiana/Petersburg', 'America/Indiana/Tell_City', 'America/Indiana/Vevay', 'America/Indiana/Vincennes', 'America/Indiana/Winamac', 'America/Juneau', 'America/Kentucky/Louisville', 'America/Kentucky/Monticello', 'America/Los_Angeles', 'America/Menominee', 'America/Metlakatla', 'America/New_York', 'America/Nome', 'America/North_Dakota/Beulah', 'America/North_Dakota/Center', 'America/North_Dakota/New_Salem', 'America/Phoenix', 'America/Sitka', 'America/Yakutat', 'Pacific/Honolulu'] },
    { code: 'UY', name: 'Uruguay', zones: ['America/Montevideo'] },
    { code: 'UM', name: 'US minor outlying islands', zones: ['Pacific/Midway', 'Pacific/Wake'] },
    { code: 'UZ', name: 'Uzbekistan', zones: ['Asia/Samarkand', 'Asia/Tashkent'] },
    { code: 'VU', name: 'Vanuatu', zones: ['Pacific/Efate'] },
    { code: 'VA', name: 'Vatican City', zones: ['Europe/Vatican'] },
    { code: 'VE', name: 'Venezuela', zones: ['America/Caracas'] },
    { code: 'VN', name: 'Vietnam', zones: ['Asia/Ho_Chi_Minh'] },
    { code: 'VG', name: 'Virgin Islands (UK)', zones: ['America/Tortola'] },
    { code: 'VI', name: 'Virgin Islands (US)', zones: ['America/St_Thomas'] },
    { code: 'WF', name: 'Wallis & Futuna', zones: ['Pacific/Wallis'] },
    { code: 'EH', name: 'Western Sahara', zones: ['Africa/El_Aaiun'] },
    { code: 'YE', name: 'Yemen', zones: ['Asia/Aden'] },
    { code: 'ZM', name: 'Zambia', zones: ['Africa/Lusaka'] },
    { code: 'ZW', name: 'Zimbabwe', zones: ['Africa/Harare'] },
];
